import { AuctionStatuses, unaccent } from 'vdlib';
import { I18n as I } from 'react-redux-i18n';

const filterOption = (input, option) => {
  const inputText = unaccent(input).toLowerCase();
  const optionText = unaccent(option.children).toLowerCase();
  return optionText.indexOf(inputText) >= 0;
};

const formatTitle = title =>
  Array.isArray(title) ? title.map(part => I.t(part)).join(' ') : I.t(title);

const requiresMerchant = ({ isMerchant }) => isMerchant;
const requiresInsuranceOperatorExpert = ({
  isExpert,
  isInsurance,
  isOperator,
}) => isExpert || isInsurance || isOperator;
const requiresOperator = ({ isOperator }) => isOperator;
const requiresOperatorAndPending = ({ columnDefsKey, isOperator }) =>
  isOperator && columnDefsKey.indexOf(AuctionStatuses.Pending);
const always = () => true;

const filterData = [
  { name: 'ID', title: 'ID', type: 'text', visible: always },
  {
    name: 'PartDescription',
    title: 'DESCRIPTION',
    type: 'text',
    visible: always,
  },
  {
    name: 'PartNumber',
    title: 'PART_NUMBER',
    type: 'text',
    visible: always,
  },
  {
    name: 'FolderNumber',
    title: 'FOLDER_NO',
    type: 'text',
    visible: requiresInsuranceOperatorExpert,
  },
  {
    name: 'PlateNumber',
    title: 'PLATE_NUMBER',
    type: 'text',
    visible: requiresInsuranceOperatorExpert,
  },
  {
    name: 'InsuranceID',
    optionsProp: 'insurances',
    placeholder: ['DATAGRID_CHOOSE', 'INSURANCE'],
    title: 'INSURANCE',
    type: 'dropdown',
    visible: requiresOperator,
  },
  {
    name: 'RegionID',
    optionsProp: 'regions',
    placeholder: 'CHOOSE_PREFECTURE',
    title: 'PREFECTURE',
    type: 'dropdown',
    visible: requiresMerchant,
  },
  {
    name: 'VehicleBrand',
    optionsProp: 'brands',
    placeholder: ['DATAGRID_CHOOSE', 'BRAND'],
    title: 'BRAND',
    type: 'dropdown',
    valueMember: 'Description',
    visible: always,
  },
  {
    name: 'VehicleModel',
    title: 'MODEL',
    type: 'text',
    visible: always,
  },
  {
    name: 'CreatedDate',
    placeholder: 'CREATION_DATE',
    title: 'CREATION_DATE',
    type: 'date',
    visible: requiresOperatorAndPending,
  },
];

export { filterData, filterOption, formatTitle };
